import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RoomStatus } from "~@/graphql/codegen/generated";

type ChatsCountState = {
  [RoomStatus.NonAccepted]: number;
  [RoomStatus.Accepted]: number;
  [RoomStatus.NonResponded]: number;
  [RoomStatus.Completed]: number;
  [RoomStatus.Invisible]: number;
};

const initialState: ChatsCountState = {
  [RoomStatus.NonAccepted]: 0,
  [RoomStatus.Accepted]: 0,
  [RoomStatus.NonResponded]: 0,
  [RoomStatus.Completed]: 0,
  [RoomStatus.Invisible]: 0,
};

const chatsCountSlice = createSlice({
  name: "chatsCount",
  initialState,
  reducers: {
    setChatsCount(state, action: PayloadAction<ChatsCountState>) {
      return action.payload;
    },
    setChatCountByStatus(
      state,
      action: PayloadAction<{ status: RoomStatus; count: number }>
    ) {
      state[action.payload.status] = action.payload.count;
    },
    incrementChatCount(
      state,
      action: PayloadAction<{ status: RoomStatus; delta?: number }>
    ) {
      const { status, delta = 1 } = action.payload;
      state[status] += delta;
    },
    resetChatsCount() {
      return initialState;
    },
  },
});

export const {
  setChatsCount,
  setChatCountByStatus,
  incrementChatCount,
  resetChatsCount,
} = chatsCountSlice.actions;

export default chatsCountSlice.reducer;
